/**
 * Seats promised while a subscription waits for its first payment. Utilities refuses to seat anyone
 * until the payment lands, which happens after the admin comes back from the payment page, so who
 * gets which seat is remembered here across that round trip. Per browser, and forgotten after a day.
 */
export interface PendingSeats {
  subscriptionId: string;
  userIds: string[];
  /** Seats to give back once the new ones are held. */
  releases: { subscriptionId: string; userId: string }[];
  queuedAt: string;
}

const KEY = 'klax.pending-seat-assignments';
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

export const readPendingSeats = (): PendingSeats[] => {
  try {
    const items = JSON.parse(localStorage.getItem(KEY) || '[]') as PendingSeats[];
    return items.filter((item) => Date.now() - new Date(item.queuedAt).getTime() < MAX_AGE_MS);
  } catch {
    return [];
  }
};

export const writePendingSeats = (items: PendingSeats[]) => {
  try {
    if (items.length) localStorage.setItem(KEY, JSON.stringify(items));
    else localStorage.removeItem(KEY);
  } catch {
    // Storage refused: the admin gives the seats from the Plan column once the payment lands.
  }
};

export const queuePendingSeats = (item: Omit<PendingSeats, 'queuedAt'>) =>
  writePendingSeats([
    ...readPendingSeats().filter((pending) => pending.subscriptionId !== item.subscriptionId),
    { ...item, queuedAt: new Date().toISOString() },
  ]);
